<template>
  <main id="aboutusMainContainer">
    <div class="container-fluid px-0">
      <b-row>
        <b-col cols="12">
          <div class="custom_page_header">
            <h2>{{$t('message.experly_structured')}}</h2>
            <p class="lead">{{$t('message.effective_sol')}}</p>
          </div>
        </b-col>
      </b-row>
      <b-row class="pt-2 justify-content-center aboutusMain">
          <b-col cols="12">
              <p>{{$t(`message.ourcom`)}}</p>
              <p>{{$t(`message.weddoffer`)}}</p>
              <p>{{$t(`message.multiple_cases`)}}</p>
          </b-col>
          <b-col cols="12" class="pt-2">
              <h3 class="text-center">{{$t(`message.trdistchannel`)}}</h3>
              <p class="lead text-center">{{$t(`message.trdistthrough`)}}</p>
              <b-list-group class="text-center listb2b">
                <b-list-group-item class="font-600">B2B Platform</b-list-group-item>
                <b-list-group-item class="font-600">API</b-list-group-item>
                <b-list-group-item class="font-600">Direct</b-list-group-item>
              </b-list-group>
          </b-col>
      </b-row>
      <b-row class="pt-2">
          <b-col cols="12">
              <h3 class="text-center">{{$t(`message.wawmyactot`)}}</h3>
          </b-col>            
      </b-row>
      <card-advance-profile class="aboutusMain"/>
    </div> 
  </main>
</template>

<script>
import { BRow, BCol, BListGroup, BListGroupItem } from 'bootstrap-vue'
import CardAdvanceProfile from '../card/card-advance/CardAdvanceProfile.vue'
export default {
  components: {
    BRow,
    BCol,
    CardAdvanceProfile,
    BListGroup,
    BListGroupItem
  },
}
</script>
<style scoped>
  .listb2b > .list-group-item{
    color: var(--foreground-color);
  }
</style>